module.exports = __webpack_public_path__ + "assets/public/imgs/logos/spring-boot.svg";